import { SpeakerFaceCoordinatesResponse } from '@goldcast/api/content';
import { getPlayerConfig } from '@goldcast/player-config/src/generators/config';
import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { CompositionConfig } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';
import { SceneChanges } from '@goldcast/player-config/src/types/scene-changes';
import { ContentMetadataStoreFactoryType } from '@goldcast/player-config/src/stores/contentMetadataStoreFactory';
import { BrandKitStore, PlatformBrandKitStore } from '@goldcast/player-config/src/types/brand-kit-types';
import { useContentMetadataStore } from '@/stores/contentMetaDataStore/contentMetaDataStore';
import {
  currentClip,
  isFullVideoFaceRecEnabled,
  isFullVideoFaceRecForPreRecordedEnabled,
  isScreenShareDetectionFeatureFlagEnabled
} from '@/stores/clip';
import { zoomLevelStore } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/store/zoomLevel';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';
import { currentUser } from '@/stores/user';
import { brandKit, clipsBrandKit, platformBrandKitStore } from '@/stores/brandKit';

export const getImpureCommonPropsForPlayerConfigGeneration = (
  clipId: string
): {
  isFullFaceRecEnabled: boolean;
  isFullFaceRecForPreRecordedEnabled: boolean;
  isScreenshareDetectionEnabled: boolean;
  isPlatformBrandKitEnabled: boolean;
  clipBrandKitStore: BrandKitStore;
  brandKitStore: BrandKitStore;
  platformBrandKit: PlatformBrandKitStore;
  organization?: string | null | undefined;
  isSplitsTranslationEnabled: boolean;
  zoomLevel: number;
  previousClip: Clip;
  contentMetadataStoreInstance: ContentMetadataStoreFactoryType;
} => {
  return {
    isFullFaceRecEnabled: isFullVideoFaceRecEnabled(),
    isFullFaceRecForPreRecordedEnabled: isFullVideoFaceRecForPreRecordedEnabled(),
    isScreenshareDetectionEnabled: isScreenShareDetectionFeatureFlagEnabled(),
    isPlatformBrandKitEnabled: !!featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Platform_Brandkit],
    clipBrandKitStore: clipsBrandKit.getSnapshot()[clipId],
    brandKitStore: brandKit.getSnapshot(),
    platformBrandKit: platformBrandKitStore.getSnapshot(),
    organization: currentUser.getSnapshot()?.organization,
    isSplitsTranslationEnabled: !!featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Splits_Translations],
    zoomLevel: zoomLevelStore.getSnapshot().zoomLevel,
    previousClip: currentClip.getSnapshot()[clipId],
    contentMetadataStoreInstance: useContentMetadataStore
  };
};

export const getPlayerConfigHelper = ({
  clip,
  sceneOverrides,
  shouldUpdatePlayerConfig,
  facialRecognitionToDefaultPosition
}: {
  clip: Clip;
  sceneOverrides?: SceneChanges;
  shouldUpdatePlayerConfig?: boolean;
  facialRecognitionToDefaultPosition?: SpeakerFaceCoordinatesResponse;
}): CompositionConfig => {
  return getPlayerConfig({
    clip,
    sceneOverrides,
    shouldUpdatePlayerConfig,
    facialRecognitionToDefaultPosition,
    ...getImpureCommonPropsForPlayerConfigGeneration(clip.id)
  });
};
